import { IconButton } from '@material-ui/core';
import { ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement, useContext } from 'react';
import { ObosX } from '../../../../../icons/obos/obosIcons';
import { AppContext } from '../../../../../state/app.state';
import { ToggleValuesT } from '../ObjectView';

type ObjectViewIframesProps={
    showIframeOne: boolean;
    showIframeTwo: boolean;
    selectedObject: ObjectContainerClientT;
    toggleShow: (value: ToggleValuesT) => void;
};

const ObjectViewIframes: React.FC<ObjectViewIframesProps> = ({ showIframeOne, showIframeTwo, toggleShow, selectedObject }): ReactElement => {
    const { state } = useContext(AppContext);

    return (
        <>
            {showIframeOne && <>
                <iframe allowFullScreen className='bv-objectview-tour' src={state?.project?.tours?.find(t => t.id === selectedObject.iframeOneId)?.url || ''} title='Rundvandring'/>
            </>}
            {showIframeTwo &&
                <iframe allowFullScreen className='bv-objectview-tour' src={state?.project?.tours?.find(t => t.id === selectedObject.iframeTwoId)?.url || ''} title='3D-Planritning med mätegenskaper'/>
            }</>
    );
};


export default ObjectViewIframes;